module.exports = __webpack_public_path__ + "c205e21c648b46057632f4ed5bec012a.png";